import React, { useState, useRef } from 'react';
import '../Components/StopWatch.css';

const StopWatch = () => {
    const [time, setTime] = useState({ hr: 0, min: 0, sec: 0, milli: 0 });
    const [laps, setLaps] = useState([]); // State to store lap times
    const intervalRef = useRef(null); // Ref to store interval ID

    let updHr = time.hr;
    let updMin = time.min;
    let updSec = time.sec;
    let updMilli = time.milli;

    const start = () => {
        if (!intervalRef.current) { // Only start if no interval is running
            intervalRef.current = setInterval(myFun, 10);
        }
    };

    const stop = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null; // Reset intervalRef
        }
    };

    const reset = () => {
        stop(); // Stop the timer
        setTime({ hr: 0, min: 0, sec: 0, milli: 0 });
        setLaps([]); // Clear lap times
    };

    const lap = () => {
        const lapTime = `${time.hr} : ${time.min} : ${time.sec} : ${time.milli}`;
        setLaps([...laps, lapTime]);
    };

    const myFun = () => {
        if (updMilli === 100) {
            updMilli = 0;
            updSec++;
        }

        if (updSec === 60) {
            updSec = 0;
            updMin++;
        }

        if (updMin === 60) {
            updMin = 0;
            updHr++;
        }
        updMilli++;
        setTime({ hr: updHr, min: updMin, sec: updSec, milli: updMilli });
    };

    return (
        <>
            <div className="container">
                <h1>{time.hr + ' : ' + time.min + ' : ' + time.sec + ' : ' + time.milli}</h1>
                <div className="buttons">
                    <button className="start" onClick={start}>Start</button>
                    <button className="stop" onClick={stop}>Stop</button>
                    <button className="reset" onClick={reset}>Reset</button>
                    <button className="lap" onClick={lap}>Lap</button>
                </div>
                <div className="lap-list">
                    <h3>Laps:</h3>
                    <ul>
                        {laps.map((lap, index) => (
                            <li key={index}>{`Lap ${index + 1}: ${lap}`}</li>
                        ))}
                    </ul>
                </div>
            </div>
        </>
    );
};

export default StopWatch;
